'use client';

import Link from 'next/link';
import { FiArrowDown, FiArrowRight } from 'react-icons/fi';

export default function CategoryCTAButtons() {
    const handleScrollToContent = () => {
        const childrenSection = document.querySelector('#children-section');
        if (childrenSection) {
            childrenSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    const primaryButtonStyle = {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        padding: '14px 32px',
        borderRadius: '12px',
        border: 'none',
        background: 'linear-gradient(135deg, #E8604C 0%, #313041 100%)',
        color: '#ffffff',
        fontSize: '1rem',
        fontWeight: '600',
        textDecoration: 'none',
        transition: 'box-shadow 0.25s ease, transform 0.2s ease',
        cursor: 'pointer',
    };

    const secondaryButtonStyle = {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        padding: '14px 32px',
        borderRadius: '12px',
        border: '2px solid transparent',
        backgroundImage: 'linear-gradient(white, white), linear-gradient(135deg, #E8604C, #313041)',
        backgroundOrigin: 'border-box',
        backgroundClip: 'padding-box, border-box',
        color: '#313041',
        fontSize: '1rem',
        fontWeight: '600',
        textDecoration: 'none',
        transition: 'color 0.25s ease, transform 0.2s ease',
        cursor: 'pointer',
    };

    return (
        <div className="flex flex-col md:flex-row gap-3">
            <button
            className='w-full'
                onClick={handleScrollToContent}
                style={primaryButtonStyle}
                onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                }}
            >
                <span>Explore Our Packages</span>
                <FiArrowDown className="w-5 h-5" aria-hidden="true" />
            </button>
            <Link
            className='w-full'
                href="/tailor-made"
                style={secondaryButtonStyle}
                onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#E8604C';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.color = '#313041';
                    e.currentTarget.style.transform = 'translateY(0)';
                }}
            >
                <span>Create Custom Package</span>
                <FiArrowRight className="w-5 h-5" aria-hidden="true" />
            </Link>
        </div>
    );
}
